module.exports = __webpack_public_path__ + "media/images/icons/icons_small/40_groom-467e7cf934617610822fce3a278f284d.png";